import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import Button from '../../Button';

export interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
}

/**
 * Domain-specific shim around the canonical <Button> primitive.
 * Icon-only `×` for modals, partner-detail headers, and any in-panel
 * dismiss affordance. Always renders with an aria-label.
 */
export default function CloseButton({
  onClick,
  ariaLabel = 'Close',
  className,
  disabled,
}: CloseButtonProps) {
  return (
    <Button
      variant="tertiary"
      size="sm"
      iconOnly
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      <XMarkIcon aria-hidden="true" />
    </Button>
  );
}
